<template>
  <div>
    <v-dialog
      @keydown.esc="isOpen=false"
      persistent
      v-model="isOpen"
      width="500">
      <v-card>
        <v-card-title>
          Crear banco o caja
        </v-card-title>
        <v-card-text>
          <v-form v-model="isValid" ref="create">
            <v-row>
              <v-col cols="12" class="py-0">
                <v-text-field
                  rounded
                  outlined
                  dense
                  v-model="form.name"
                  :rules="rules.name"
                  label="Nombre"
                />
              </v-col>
              <v-col cols="12" class="py-0">
                <v-select
                  :disabled="!!form._id"
                  rounded
                  outlined
                  dense
                  item-text="text"
                  item-value="value"
                  :items="[
                    { text: 'Banco', value: 'bank' },
                    { text: 'Caja', value: 'cash' }
                  ]"
                  v-model="form.kind"
                  :rules="rules.required"
                  label="Tipo"
                />
              </v-col>
              <v-col cols="12" class="py-0">
                <div class="d-flex">
                  <v-select
                    :disabled="!!form._id"
                    rounded
                    outlined
                    dense
                    item-text="name"
                    item-value="_id"
                    :items="accounts"
                    v-model="form.account"
                    :rules="rules.required"
                    label="Cuenta"
                  />
                  <div class="pl-3">
                    <v-tooltip top v-if="expensesPermissions['create-bank-account']">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          :disabled="!!form._id"
                          fab
                          color="primary"
                          x-small
                          depressed
                          @click="openAddAccountDialog(null)"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Agregar cuenta</span>
                    </v-tooltip>
                    <AddAccount
                      ref="addAccount"
                      @updated="loadAccounts"
                    />
                  </div>
                </div>
              </v-col>
              <v-col cols="12" class="py-0">
                <v-text-field
                  :disabled="!!form._id"
                  rounded
                  outlined
                  dense
                  v-model="form.number"
                  :rules="rules.required"
                  :label="form.type === 'Banco' ? 'Número de cuenta' : 'Identificador'"
                />
              </v-col>
              <v-col cols="12" class="py-0">
                <v-text-field
                  :disabled="!!form._id"
                  type="number"
                  rounded
                  outlined
                  dense
                  v-model="form.startAmount"
                  :rules="[...rules.required, ...rules.number]"
                  label="Saldo Inicial"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mr-4"
            rounded
            outlined
            small
            depressed
            @click="closeDialog">
            {{ $t('ctas.close') }}
          </v-btn>
          <v-btn
            color="primary"
            rounded
            dark
            small
            depressed
            @click="create">
            {{ $t('ctas.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import AddAccount from '@/components/modals/AddAccount'

export default {
  components: {
    AddAccount
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      isValid: false,
      form: {
        name: null,
        kind: null,
        account: null,
        number: null,
        startAmount: null
      },
      accounts: [],
      rules: {
        name: [v => !!v || `${this.$i18n.t('recipes.labels.name')} ${this.$i18n.t('messages.isRequired')}`],
        required: [v => !!v || `Este campo ${this.$i18n.t('messages.isRequired')}`],
        number: [v => v >= 0 || 'Se requiere un número positivo']
      }
    }
  },
  computed: {
    expensesPermissions () {
      return this.$store.state.login.permissions['expenses'].components['bank-accounts'].actions
    }
  },
  async mounted () {
    await this.loadAccounts({
      restaurant: this.$store.state.currentRestaurant.data._id
    })
  },
  methods: {
    openAddAccountDialog: function () {
      this.$refs.addAccount.openDialog()
    },
    openDialog (bank) {
      if (bank) {
        this.form = { ...bank }
        this.form.account = bank.account._id
      }
      this.isOpen = true
    },
    closeDialog () {
      this.isOpen = false
      this.form = {
        name: null,
        kind: null,
        account: null,
        number: null,
        startAmount: null
      }
      this.$refs.create.reset()
    },
    async create () {
      this.$refs.create.validate()
      if (this.isValid) {
        this.overlay = true
        try {
          const payload = {
            // Todo: send initial balance to api
            ...this.form,
            restaurant: this.$store.state.currentRestaurant.data._id
          }
          if (payload._id) {
            await this.$api.put(`/v1/financial/balance-accounts/${payload._id}`, payload)
          } else {
            await this.$api.post(`/v1/financial/balance-accounts`, payload)
          }
          this.$emit('updated')
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
        this.closeDialog()
      }
    },
    async loadAccounts (params = null) {
      params = params || {
        restaurant: this.$store.state.currentRestaurant.data._id
      }
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/financial/unit-accounts`, params)
        this.accounts = response
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    }
  }
}
</script>
